import { useState } from "react";
import { Sparkles, X } from "lucide-react";
import { api } from "../../lib/api";
import { useAuth } from "../../contexts/AuthContext";

// One-time note for founders whose journey was reset (Sept 2026). Dismiss = ack.
export function ResetWelcomeBack({ noun = "business" }) {
  const { user, refresh } = useAuth();
  const [hidden, setHidden] = useState(false);
  if (!user?.reset_notice_pending || hidden) return null;
  const first = (user.name || "").trim().split(" ")[0] || "there";
  const dismiss = async () => {
    setHidden(true);
    try { await api.post("/auth/reset-notice/ack"); await refresh(); } catch { /* best-effort */ }
  };
  return (
    <div data-testid="reset-welcome-back" className="mb-8 flex items-start gap-3 rounded-2xl border border-[#0A8B85]/40 bg-[#0A8B85]/10 px-5 py-4 text-sm leading-relaxed text-teal-50">
      <Sparkles className="mt-0.5 h-4 w-4 flex-shrink-0 text-[#7BD3CE]" />
      <p className="flex-1">
        <span className="font-bold">Welcome back, {first} — we&rsquo;ve refreshed your journey.</span>{" "}
        Your account, name and login are unchanged; your {noun} profile and documents have been reset so you can start
        clean from Step 1. Let&rsquo;s begin with the Get Started quiz.
      </p>
      <button type="button" onClick={dismiss} aria-label="Dismiss" data-testid="reset-welcome-back-dismiss"
        className="rounded-full p-1 text-teal-100/70 transition-colors hover:bg-white/10 hover:text-white">
        <X className="h-4 w-4" />
      </button>
    </div>
  );
}
